import { render } from "./TeamItem.vue?vue&type=template&id=772d38b8&scoped=true"
import script from "./TeamItem.vue?vue&type=script&lang=js"
export * from "./TeamItem.vue?vue&type=script&lang=js"

import "./TeamItem.vue?vue&type=style&index=0&id=772d38b8&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites safe 2026/Safe_Sites_Modifs/SAFE_GROUP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772d38b8"]])

export default __exports__